import { ClockCircleOutlined } from '@ant-design/icons';
import { Switch } from 'antd';
import type { FC } from 'react';
import { useDebouncedCallback } from 'use-debounce';

export const AcuteFilterSwitch: FC<{
  onChange: (acute: boolean) => void;
}> = ({ onChange }) => {
  // debounce due to performance
  const debounced = useDebouncedCallback(checked => onChange(checked), 200);
  return (
    <Switch
      onChange={checked => debounced(checked)}
      checkedChildren={
        <>
          <ClockCircleOutlined /> Akut
        </>
      }
      unCheckedChildren={
        <>
          <ClockCircleOutlined /> Akut
        </>
      }
    />
  );
};
